import {
    IConfiguratorProxy,
    IOptionChoiceAvailabilityMap,
    IOptionItemAvailableChoice,
    IOptionItemChoice
} from "@bimaire/optionslib";
import React from "react";
import {useNavigate} from "react-router-dom";
import {normalizeOptions} from "../vscSiteSpecific/SiteSpecific";
import groupBy from "@bimaire/optionslib/build/utils/groupBy";
import {ConfiguratorValues} from "./ConfiguratorValues";
import styled from "@emotion/styled/macro";
import {ThemeColors} from "../../layout/GlobalLayout";
import {useUnreal} from "../../../unreal_api/useUnreal";
import {IOptionConfig} from "../../../data/IViewpoint";
import {getChoices} from "../../../data/getViewOptions";

const SelectionsDiv = styled.section`
    padding: 32px 16px 0px 16px;
    height: 100%;
    max-width: 300px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .back {

        align-self: flex-start;
    }

    .optionsscroller {

        overflow: scroll;
    }

    h3 {
        font-family: 'Bw Nista Geometric';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        /* identical to box height */

        text-align: center;

        /* Dark Platinum */

        color: ${ThemeColors.darkplatinum};

    }

    h4 {
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        line-height: 25px;

    }
`

export interface IConfiguratorSelectionsProps {
    configurator: IConfiguratorProxy;
    lotId: string;
    optionsVisible: IOptionConfig[] | undefined;
    onSelect: (opt: IOptionItemChoice) => void;
    viewOptions: Record<string, string> // e.g. VSC-VIEW, VSC-FURN.

}

function isOptionAvailable(availabilityMap: IOptionChoiceAvailabilityMap, choice: IOptionItemAvailableChoice) {
    const av = availabilityMap.availability.get(choice);
    if (av === undefined) return false;
    return av.isEnabled && av.isVisible;
}

export const UnrealOptions: React.FC<{ choices: IOptionItemChoice[], lotId: string }> = (props) => {
    const {choices, lotId} = props;
    const unrealOpts = useUnreal(choices, lotId);
    return null;
}
export const ConfiguratorSelections: React.FC<IConfiguratorSelectionsProps> = (props) => {

    const {configurator, onSelect, lotId, optionsVisible, viewOptions} = props;

    const navigate = useNavigate();
    const allChoices = configurator.getAllChoices();
    const optionsVisibleNormalized = normalizeOptions(optionsVisible);


    const optionsVisibleIds = optionsVisibleNormalized?.map(ov => ov.id);

    const enabledChoices = optionsVisibleIds === undefined ? allChoices : allChoices.filter(ch => optionsVisibleIds.includes(ch.items[0].item.id));
    const avail = configurator.getOptionAvailability(enabledChoices);
    const visibleChoices = enabledChoices.filter(ch => isOptionAvailable(avail, ch));
    let activeChoices = configurator.getChoices();

    const viewChoices = getChoices(viewOptions);
    for (const vc of viewChoices) {
        activeChoices.push(vc);
    }

    const choicesByOption = groupBy(visibleChoices, ch => ch.items[0].item.id);
    return <SelectionsDiv>

        <div className={"back"}>
            <a href='#' onClick={(ev: React.MouseEvent) => {
                ev.preventDefault();
                navigate(-1);
            }} className={"back"}>
                &lt; Back</a>

        </div>
        <div className={"optionsscroller"}>
            <div className={"options"}>

                <UnrealOptions choices={activeChoices} lotId={lotId}/>
                {Object.keys(choicesByOption).map(selId => <div>
                    <ConfiguratorValues selection={choicesByOption[selId][0].items[0].item}
                                        values={choicesByOption[selId]}
                                        selectedChoice={activeChoices.find(ch => ch.choice.items[0].item.id === selId)!}
                                        onSelect={onSelect}
                    />
                </div>)}
            </div>
        </div>
    </SelectionsDiv>


}